import React from 'react';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  author as AuthorPropType,
  person as PersonPropType,
} from 'lib/CustomPropTypes';

import {
  BylineList,
  BylineThumbnail,
} from 'components/Byline';
import ContentTimestamp from 'components/ContentTimestamp';

import styles from './styles.module.scss';

export const ShowBlogByline = ({
  authors = [],
  dateCreated = null,
  datePublished = null,
  source = null,
  additionalClasses = '',
}) => {
  const { t } = useTranslation();

  const showThumbnail = authors && authors.length === 1;
  const showBylineList = authors && authors.length !== 0;
  // Account for different anatomies of the person object
  const authorForThumbnail = authors && get(authors[0], 'person', authors[0]);

  return (
    <div
      className={`${styles.showBlogByline} ${additionalClasses}`}
      data-test="byline-container"
      data-testid="byline-container"
    >
      {showThumbnail && (
        <BylineThumbnail
          person={authorForThumbnail}
          additionalClasses={styles.bylineThumbnail}
        />
      )}
      <div className="df flex-column mv-auto">
        <div className={styles.dateSource}>
          <ContentTimestamp
            dateCreated={dateCreated}
            datePublished={datePublished}
            delimiter=", "
            meta
            showCreatedDate
          />
          {source?.organization && (
            <span>
              {(dateCreated || datePublished) ? ' / ' : ''}
              {t('Source')}
              {': '}
              {source.organization.name}
            </span>
          )}
        </div>
        {showBylineList && (
          <p
            className={styles.nameWrapper}
            data-test="byline"
            data-testid="byline"
          >
            {t('By')}
            {' '}
            <BylineList
              authors={authors}
            />
          </p>
        )}
      </div>
    </div>
  );
};

ShowBlogByline.propTypes = {
  authors: PropTypes.arrayOf(
    AuthorPropType || PersonPropType,
  ),
  dateCreated: PropTypes.string,
  datePublished: PropTypes.string,
  source: PropTypes.shape({}),
  additionalClasses: PropTypes.string,
};

